/* eslint-disable react-hooks/exhaustive-deps */
import "./App.css";
import React, { Suspense, useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { Spin, App as AntdApp, ConfigProvider } from "antd";
import SiteLoader from "./views/components/SiteLoader";
import Loader from "./views/components/loader";
import "./notification";

// Spinner configuration
Spin.setDefaultIndicator(
  <div>
    <Loader />
  </div>
);

const LayoutAdmin = React.lazy(() => import("./views/layout/Layout"));
const Login = React.lazy(() => import("./views/pages/Login"));

function App() {
  const [isLoggedin, setIsLoggedin] = useState(false);
  const [ajxRequesting, setAjxRequesting] = useState(true); // Default true rakha hai initial check ke liye

  useEffect(() => {
    // 1. Loader start karein
    setAjxRequesting(true);
    
    // 2. Check authentication
    const token = window.localStorage.getItem("authorization");
    if (token) {
      setIsLoggedin(true);
    }

    // 3. Chota sa delay taaki flickering na ho, phir loader band karein
    setTimeout(() => {
      setAjxRequesting(false);
    }, 500);
  }, []);

  return (
    <ConfigProvider
      theme={{
        components: {
          Menu: {
            itemSelectedBg: "#164B2D",
            itemSelectedColor: "#ffffff",
          },
        },
      }}
    >
      <AntdApp>
        <BrowserRouter basename="/">
          {/* Agar checking chal rahi hai toh SiteLoader dikhayein */}
          {ajxRequesting ? (
            <SiteLoader />
          ) : isLoggedin ? (
            <Suspense fallback={<SiteLoader />}>
              <LayoutAdmin />
            </Suspense>
          ) : (
            <Suspense fallback={<SiteLoader />}>
              <Login />
            </Suspense>
          )}
        </BrowserRouter>
      </AntdApp>
    </ConfigProvider>
  );
}

export default App;